import { reactive, readonly } from 'vue'
import {
  clearStoredUserSession,
  readStoredUserEmail,
  readStoredUserId,
  writeStoredUserEmail,
  writeStoredUserId
} from '@/services/sessionStorageAdapter'

const state = reactive({
  keycloak: null,
  initialized: false,
  authenticated: false,
  userRole: 'Invité',
  userId: readStoredUserId(),
  userEmail: readStoredUserEmail(),
  outgoingSharesUsed: 0
})

export function getSessionState() {
  return readonly(state)
}

export function syncSessionStore(partial = {}) {
  Object.assign(state, partial)
  state.userId = readStoredUserId()
  state.userEmail = readStoredUserEmail()
}

export function setSessionUserId(userId) {
  writeStoredUserId(userId)
  state.userId = readStoredUserId()
}

export function setSessionUserEmail(email) {
  writeStoredUserEmail(email)
  state.userEmail = readStoredUserEmail()
}

export function setSessionOutgoingSharesUsed(count) {
  state.outgoingSharesUsed = count ?? 0
}

export function clearSessionStore() {
  clearStoredUserSession()
  state.userId = null
  state.userEmail = null
  state.authenticated = false
  state.userRole = 'Invité'
  state.outgoingSharesUsed = 0
}
